export default __webpack_public_path__ + "static/media/cb_logo_1.4d7a50b6.png";